import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HandshakeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"handshake"}/>
}
